import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  metersLoadingCachedMeters: {
    id: 'app.inventory.meters.loadingCachedMeters',
  },
  metersNoMetersMatchSearch: {
    id: 'app.inventory.meters.noMetersMatchSearch',
  },
  metersNoPlacementDetails: {
    id: 'app.inventory.meters.noPlacementDetails',
  },
  metersQueuedLocal: {
    id: 'app.inventory.meters.queuedLocal',
  },
  metersRecordsTitle: {
    id: 'app.inventory.meters.recordsTitle',
  },
  metersSavedInDb: {
    id: 'app.inventory.meters.savedInDb',
  },
  metersSearchPlaceholder: {
    id: 'app.inventory.meters.searchPlaceholder',
  },
  metersTitle: {
    id: 'app.inventory.meters.title',
  },
  metersVisible: {
    id: 'app.inventory.meters.visible',
  },
});
